import { render } from "./Profile.vue?vue&type=template&id=bf1681ae"
import script from "./Profile.vue?vue&type=script&setup=true&lang=js"
export * from "./Profile.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Profile.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bf1681ae"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bf1681ae', __exports__)) {
    api.reload('bf1681ae', __exports__)
  }
  
  module.hot.accept("./Profile.vue?vue&type=template&id=bf1681ae", () => {
    api.rerender('bf1681ae', render)
  })

}


export default __exports__